import { render, staticRenderFns } from "./ruleGroup.selector.vue?vue&type=template&id=1203e58e&lang=pug"
import script from "./ruleGroup.selector.vue?vue&type=script&lang=js"
export * from "./ruleGroup.selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports